(function ($, Promise) {

		var NORTH_WEST = Math.PI * -0.75;
		var NORTH = Math.PI * -0.5;
		var NORTH_EAST = Math.PI * -0.25;
		var EAST = Math.PI * 0;

		var SOUTH_EAST = Math.PI * 0.25;
		var SOUTH = Math.PI * 0.5;
		var SOUTH_WEST = Math.PI * 0.75
		var WEST = Math.PI * 1;

		var MESSAGE_TYPE_LANDED = 3;
		var MESSAGE_TYPE_WRONG_END = 4;
		var MESSAGE_TYPE_TOO_CLOSE = 5;

		// Constructor
		function SkillGamesGame3(renderer, parent) {

			this.parent = parent;

			this.levels = [
				{
					name: "1",
					planes: 2,
					duration: 45000,
					requiredScore: 30,
					planeSpeedFactor: 0.85,
					wind: EAST,
					gameEvents: []
				},
				{
					name: "2",
					planes: 3,
					duration: 45000,
					requiredScore: 30,
					planeSpeedFactor: 0.90,
					wind: WEST,
					gameEvents: [
						{
							time: 0.5,
							type: "setWindDirection",
							value: EAST,
						}
					]
				},
				{
					name: "3",
					planes: 4,
					duration: 45000,
					requiredScore: 30,
					planeSpeedFactor: 0.94,
					wind: EAST,
					gameEvents: [
						{
							time: 0.45,
							type: "setWindDirection",
							value: WEST,
						},
						// {
						// 	time: 0.66,
						// 	type: "setWindDirection",
						// 	value: EAST,
						// }
					]
				}
			];

			this.slotsId = 0;
			this.slots = [
				{
					x: 350,
					y: 1230,
					angle: NORTH
				},
				// {
				// 	x: 950,
				// 	y: -150,
				// 	angle: SOUTH_WEST
				// },
				{
					x: -150,
					y: 700,
					angle: EAST
				},
				{
					x: 2070,
					y: 400,
					angle: WEST
				},
				{
					x: 1000,
					y: -150,
					angle: SOUTH
				},
				// {
				// 	x: -150,
				// 	y: 250,
				// 	angle: EAST
				// },
				{
					x: 800,
					y: 1230,
					angle: NORTH
				},
				// {
				// 	x: 2070,
				// 	y: 500,
				// 	angle: WEST
				// },
				{
					x: 1600,
					y: -150,
					angle: SOUTH
				},
				{
					x: 1400,
					y: 1230,
					angle: NORTH
				},
				{
					x: -150,
					y: 300,
					angle: EAST
				},
				// {
				// 	x: 600,
				// 	y: -150,
				// 	angle: SOUTH_EAST
				// },
				{
					x: 2070,
					y: 900,
					angle: WEST
				},
				{
					x: 500,
					y: -150,
					angle: SOUTH
				},
			];
			this.lastSpotsUsed = [];

			this.tries = 0;

			this.score = 0;
			this.levelScore = 0;

			this.planesLaned = 0;
			this.levelPlanesLaned = 0;

			this.gameEventsTimers = [];
			this.multipurposeTimer = false;

			this.planes = [];
			this.landingSpots = [];

			this.state = false;
			this.renderer = renderer;
			this.stage = new PIXI.Container();
			this.ticker = new PIXI.Ticker();
			this.timeSinceChecks = 0;

			// Create a container
			this.container = new PIXI.Container();
			this.stage.addChild(this.container);

			// Add background
			var bgTexture = PIXI.Texture.from('images/skill_games/landing_airplanes/bg-field.png');
			var bgSprite = new PIXI.Sprite(bgTexture);
			bgSprite.anchor.set(0.5);
			bgSprite.position.set(1920 / 2, 1080 / 2);
			this.container.addChild(bgSprite);

			// Create landing track
			this.track = new PIXI.Container();
			this.container.addChild(this.track);
			var trackTexture = PIXI.Texture.from('images/skill_games/landing_airplanes/track.png');
			var trackSprite = new PIXI.Sprite(trackTexture);
			// trackSprite.scale.set(0.35);
			trackSprite.anchor.set(0.5);
			trackSprite.position.set(1920 / 2, 465);
			this.track.addChild(trackSprite);

			// Wind
			this.windsock = new SkillGamesGame3Windsock(this);
			this.windsock.setPosition(960, 925);
			this.container.addChild(this.windsock.graphic);

			// Wind animation
			this.windAnimation = new SkillGamesGame3WindAnimation(this);
			// this.windAnimation.setPosition(960, 925);
			this.container.addChild(this.windAnimation.graphic);

			// Create landing spots
			for (var i = 0; i < 2; i++) {
				this.landingSpots[i] = new SkillGamesGame3LandingSpot();
				this.container.addChild(this.landingSpots[i].graphic);
			}
			this.landingSpots[0].setPosition(650, 524);
			this.landingSpots[0].setAngle(EAST);
			this.landingSpots[1].setPosition(1260, 524);
			this.landingSpots[1].setAngle(WEST);

			// Create launching slots
			for (var i = 0; i < this.slots.length; i++) {
				this.slots[i].indicator = new SkillGamesGame3SlotIndicator(this, this.slots[i]);
				this.container.addChild(this.slots[i].indicator.graphic);
			}

			// Create planes
			for (var i = 0; i < 12; i++) {
				var type = (i % 2 == 0) ? "jet" : "propeller";
				this.planes[i] = new SkillGamesGame3Plane(this, type);
				this.container.addChild(this.planes[i].graphic);
			}

			// Listen for animate update
			this.ticker.add($.proxy(this.draw, this));

		}

		SkillGamesGame3.prototype.start = function () {
			// this.slots = shuffle(this.slots);
			this.state = true;
			this.startLevel(0);
			this.ticker.start();
		}

		SkillGamesGame3.prototype.stop = function () {
			this.ticker.stop();
			this.state = false;
			this.clearTimerUpdate();
		}

		SkillGamesGame3.prototype.startLevel = function (level) {

			if (this.currentLevel != level) {
				this.tries = 0;
			}

			this.levelScore = 0;
			this.levelPlanesLaned = 0;

			this.currentLevel = level;
			this.startTime = millis();
			this.updateTopBar();

			this.clearGameEventsTimers();
			this.clearTimerUpdate();

			this.parent.drawTime(1.0);

			// Reset all planes
			for (var i = 0; i < this.planes.length; i++) {
				this.planes[i].reset();
			}

			// Setup planes
			for (var i = 0; i < this.levels[level].planes; i++) {
				this.launchAirplane(i);
			}
			// Setup game events
			for (var i = 0; i < this.levels[level].gameEvents.length; i++) {
				var gameEvent = this.levels[level].gameEvents[i];
				var time = (gameEvent.time * this.levels[level].duration);

				this.gameEventsTimers[i] = setTimeout($.proxy(function (gameEvent) {
					this[gameEvent.type].apply(this, [gameEvent.value]);
				}, this, gameEvent), time);
			}

			// Set wind direction
			this.setWindDirection(this.levels[level].wind)

			this.stopped = false;

			this.timerUpdate(this.levels[this.currentLevel].duration);
		}

		SkillGamesGame3.prototype.draw = function (delta) {

			if (!this.stopped) {

				// Go through planes draw cycles
				for (var i = 0; i < this.planes.length; i++) {
					this.planes[i].draw(delta);
				}

				// Windsock
				this.windsock.draw(delta);

				// Wind animation
				this.windAnimation.draw(delta);

				// Check for events

				this.timeSinceChecks += delta;
				if (this.timeSinceChecks > 5) {
					this.checkCollisions();
					this.checkLandings();
					this.timeSinceChecks = 0;
				}
			}

			// Trigger rendering
			this.renderer.render(this.stage);
		}

		SkillGamesGame3.prototype.setWindDirection = function (direction) {

			// Setup landing spots
			for (var i = 0; i < this.landingSpots.length; i++) {
				var enabled = (this.landingSpots[i].angle == WEST && direction == EAST) || (this.landingSpots[i].angle == EAST && direction == WEST);
				this.landingSpots[i].enable(enabled);
			}

			// Setup wind
			this.windsock.setDirection(direction);

			// Setup wind animation
			this.windAnimation.setDirection(direction);
		}

		SkillGamesGame3.prototype.launchAirplane = function (index) {

			var delay = (typeof index != "undefined") ? (2000 * index) : 0;

			var planeId = -1;
			for (var i = 0; i < this.planes.length; i++) {
				if (this.planes[i].used == false) {
					planeId = i;
					break;
				}
			}
			if (planeId == -1) {
				console.log("SHOULD NOT BE HERE: Couldn't find available plane.")
				return false;
			}


			var slotToUse = this.findNiceSpotToLaunch();
			console.log("launchAirplane " + planeId + " in slot : " + slotToUse, this.slots[slotToUse]);
			this.planes[planeId].reset();
			this.planes[planeId].position.x = this.slots[slotToUse].x;
			this.planes[planeId].position.y = this.slots[slotToUse].y;
			this.planes[planeId].angle = this.planes[planeId].visibleAngle = this.slots[slotToUse].angle;
			this.planes[planeId].levelSpeed = this.levels[this.currentLevel].planeSpeedFactor;
			this.planes[planeId].startIn(delay + 500);

			this.slots[slotToUse].indicator.enable(true, this.planes[planeId]);

			// Start at next slot for next launch
			// this.slotsId = (slotToUse + 1) % this.slots.length;
		}

		SkillGamesGame3.prototype.findNiceSpotToLaunch = function () {

			var bestSpotDistance = 0;
			var bestSpot = this.slotsId;

			for (var i = 0; i < this.slots.length; i++) {
				var index = ((i + this.slotsId) % this.slots.length);
				var nearsetPlane = Number.POSITIVE_INFINITY;

				for (var j = 0; j < this.planes.length; j++) {
					if (this.planes[j].collisionOccured == true || this.planes[j].landingOccured == true) continue;
					var pos1 = this.planes[j].position;
					var pos2 = this.slots[index];
					var distance = dist(pos1.x, pos1.y, pos2.x, pos2.y);
					nearsetPlane = Math.min(nearsetPlane, distance)
				}

				if (nearsetPlane > bestSpotDistance && $.inArray(index, this.lastSpotsUsed) == -1) {
					bestSpotDistance = nearsetPlane;
					bestSpot = index;
				}
			}

			// Handle last spot used memory
			this.lastSpotsUsed.push(bestSpot);
			while (this.lastSpotsUsed.length > 5) {
				this.lastSpotsUsed.shift();
			}

			return bestSpot;

		}

		SkillGamesGame3.prototype.checkCollisions = function () {

			for (var i = 0; i < this.planes.length; i++) {
				if (this.planes[i].collisionOccured == true || this.planes[i].landingOccured == true || this.planes[i].state == false) continue;

				for (var j = 0; j < this.planes.length; j++) {
					if (this.planes[j].collisionOccured == true || this.planes[j].landingOccured == true || this.planes[j].state == false) continue;
					if (i == j) continue;

					var pos1 = this.planes[i].position;
					var pos2 = this.planes[j].position;
					var distance = dist(pos1.x, pos1.y, pos2.x, pos2.y);

					if (distance < this.planes[i].logicSize) {

						// Show in game
						this.showInGameMessage(MESSAGE_TYPE_TOO_CLOSE, (this.planes[i].position.x + this.planes[j].position.x) / 2, (this.planes[i].position.y + this.planes[j].position.y) / 2,)

						// Handle score
						var points = -10;
						this.score += points;
						this.levelScore += points;
						this.scoreUpdate();

						// console.log("COLLISION");
						this.planes[i].collision();
						this.planes[j].collision();
						this.launchAirplane(0);
						this.launchAirplane(1);

					} else if (distance < this.planes[i].logicSize * 1.5) {
						this.planes[i].toggleWarning(true);
						this.planes[j].toggleWarning(true);

					} else {
						this.planes[i].toggleWarning(false);
						this.planes[j].toggleWarning(false);
					}
				}
			}
		}

		SkillGamesGame3.prototype.checkLandings = function () {

			// Go through spots and planes to check if an airplane is ready to land
			for (var i = 0; i < this.planes.length; i++) {
				if (this.planes[i].collisionOccured == true || this.planes[i].landingOccured == true || this.planes[i].state == false || this.planes[i].outOfScreen) continue;
				for (var j = 0; j < this.landingSpots.length; j++) {
					var pos1 = this.planes[i].position;
					var pos2 = this.landingSpots[j].position;
					var distance = dist(pos1.x, pos1.y, pos2.x, pos2.y);
					var angleDistance = (Math.abs(this.planes[i].angle - this.landingSpots[j].graphic.rotation)) % (Math.PI * 2);

					if (distance < this.landingSpots[j].logicSize && angleDistance < Math.PI / 2) {
						var points = (this.landingSpots[j].enabled) ? 10 : 00;

						// Show messaage
						if (points > 0) {
							this.showInGameMessage(MESSAGE_TYPE_LANDED, this.planes[i].position.x, this.planes[i].position.y - 100)
						} else {
							this.showInGameMessage(MESSAGE_TYPE_WRONG_END, this.planes[i].position.x, this.planes[i].position.y - 100)
						}

						// Handle score
						this.score += points;
						this.levelScore += points;
						this.scoreUpdate();
						this.planesLaned++;
						this.levelPlanesLaned++;

						// Handle plane
						this.planes[i].land(this.landingSpots[j]);
						this.launchAirplane();
					}
				}
			}
		}

		SkillGamesGame3.prototype.timeUp = function () {
			this.stopped = true;
			this.clearTimerUpdate();

			for (var i = 0; i < this.planes.length; i++) {
				this.planes[i].hide();
				this.planes[i].cancelLaunch();
			}

			for (var i = 0; i < this.slots.length; i++) {
				this.slots[i].indicator.reset();
			}

			// Route after end of game (timeout)
			if (this.levelScore >= this.levels[this.currentLevel].requiredScore && (this.currentLevel + 1) >= this.levels.length) {
				console.log("succes game");
				this.completeGame();
			} else if (this.levelScore >= this.levels[this.currentLevel].requiredScore) {
				console.log("succes level")
				this.successLevel();
			} else if (this.tries == 0) {
				console.log("first fail game")
				this.firstFailGame();
			} else {
				console.log("second fail game")
				this.secondFailGame();
			}
		}

		SkillGamesGame3.prototype.firstFailGame = function () {

			this.tries++;

			// Show feedback
			this.parent.showFeedback("game3-try-again");

			// Auto close
			this.clearMultipurposeTimer();
			this.multipurposeTimer = setTimeout($.proxy(function () {
				this.tryAgain();
			}, this), 5000);
		}

		SkillGamesGame3.prototype.tryAgain = function () {
			this.clearMultipurposeTimer();
			this.parent.closeFeedback();
			this.startLevel(this.currentLevel);
		}

		SkillGamesGame3.prototype.secondFailGame = function () {

			// Update top bar
			$("#game-feedback-game3-feedback .level-reached").html((this.currentLevel + 1));
			// $("#game-feedback-game3-feedback .total-score").html(this.score);
			$("#game-feedback-game3-feedback .total-score").html(this.levelScore);
			$("#game-feedback-game3-feedback .total-planes .value-holder").html(this.levelPlanesLaned);
			$("#game-feedback-game3-feedback .total-planes .count-zero").toggle(this.levelPlanesLaned == 0);
			$("#game-feedback-game3-feedback .total-planes .count-one").toggle(this.levelPlanesLaned == 1);
			$("#game-feedback-game3-feedback .total-planes .count-more-than-one").toggle(this.levelPlanesLaned > 1);

			// Set popup content
			$("#game-feedback-game3-feedback .success").hide()
			$("#game-feedback-game3-feedback .trigger").hide()
			$("#game-feedback-game3-feedback .fail").show()
			$("#game-feedback-game3-feedback .title").show()
			$("#game-feedback-game3-feedback .trigger.fail").show()

			// Add star
			$("#game-trigger-3").addClass("failed")
			$("#game-feedback-game3-feedback").removeClass("success");

			// Show feedback
			this.parent.showFeedback("game3-feedback");
		}

		SkillGamesGame3.prototype.successLevel = function () {

			// Update top bar
			$("#game-feedback-game3-feedback .level-reached").html((this.currentLevel + 1));
			// $("#game-feedback-game3-feedback .total-score").html(this.score);
			$("#game-feedback-game3-feedback .total-score").html(this.levelScore);
			$("#game-feedback-game3-feedback .total-planes .value-holder").html(this.levelPlanesLaned);
			$("#game-feedback-game3-feedback .total-planes .count-zero").toggle(this.levelPlanesLaned == 0);
			$("#game-feedback-game3-feedback .total-planes .count-one").toggle(this.levelPlanesLaned == 1);
			$("#game-feedback-game3-feedback .total-planes .count-more-than-one").toggle(this.levelPlanesLaned > 1);

			// Set popup content
			$("#game-feedback-game3-feedback .trigger").hide()
			$("#game-feedback-game3-feedback .trigger.nextLevel").show()
			$("#game-feedback-game3-feedback .fail").hide()
			$("#game-feedback-game3-feedback .success").show()
			$("#game-feedback-game3-feedback .title").show()

			// Add star
			// $("#game-trigger-3").addClass("completed")
			$("#game-feedback-game3-feedback").addClass("success");

			// Show feedback
			this.parent.showFeedback("game3-feedback");
		}

		SkillGamesGame3.prototype.completeGame = function () {

			// Update top bar
			$("#game-feedback-game3-feedback .level-reached").html((this.currentLevel + 1));
			// $("#game-feedback-game3-feedback .total-score").html(this.score);
			$("#game-feedback-game3-feedback .total-score").html(this.levelScore);
			$("#game-feedback-game3-feedback .total-planes .value-holder").html(this.levelPlanesLaned);
			$("#game-feedback-game3-feedback .total-planes .count-zero").toggle(this.levelPlanesLaned == 0);
			$("#game-feedback-game3-feedback .total-planes .count-one").toggle(this.levelPlanesLaned == 1);
			$("#game-feedback-game3-feedback .total-planes .count-more-than-one").toggle(this.levelPlanesLaned > 1);

			// Set popup content
			$("#game-feedback-game3-feedback .trigger").hide()
			$("#game-feedback-game3-feedback .trigger.completed").show()
			$("#game-feedback-game3-feedback .fail").hide()
			$("#game-feedback-game3-feedback .success").show()
			$("#game-feedback-game3-feedback .title").show()

			// Add star
			$("#game-trigger-3").addClass("completed")
			$("#game-feedback-game3-feedback").addClass("success");

			// Show feedback
			this.parent.showFeedback("game3-feedback");
		}

		SkillGamesGame3.prototype.nextLevel = function () {
			console.log("next level")
			this.parent.closeFeedback();
			this.startLevel(this.currentLevel + 1);
		}

		SkillGamesGame3.prototype.timerUpdate = function (duration) {

			// Set inital text
			$("#game-top-bar #game-top-bar-timer .time-left").text(duration / 1000);

			// Start timer
			this.clearTimerUpdate();
			this.timerUpdateInterval = setInterval($.proxy(function (duration) {
				var timeleft = constrain(Math.ceil((duration - (millis() - this.startTime)) / 1000), 0, duration / 1000);
				$("#game-top-bar #game-top-bar-timer .time-left").text(timeleft);
				if (timeleft <= 0) {
					this.clearTimerUpdate();
					this.timeUp();
				}

				var timeNorm = timeleft / (duration / 1000);
				this.parent.drawTime(timeNorm);

			}, this, duration), 1000);
		}

		SkillGamesGame3.prototype.scoreUpdate = function () {
			// $("#game-top-bar .current-score").text(numberPad(this.score, 3));
			$("#game-top-bar .current-score").text(numberPad(this.levelScore, 3));
		}

		SkillGamesGame3.prototype.updateTopBar = function () {
			$("#game-top-bar").removeClass("no-score no-timer").addClass("no-tries");

			if (this.currentLevel !== false) {
				$("#game-top-bar #game-top-bar-timer .time-left").text(Math.ceil(this.levels[this.currentLevel].duration / 1000));
				$("#game-top-bar .current-level").text(this.levels[this.currentLevel].name);
			} else {
				$("#game-top-bar #game-top-bar-timer .time-left").text("");
				$("#game-top-bar .current-level").text("");
			}

			$("#game-top-bar .total-score").html(this.score);
			this.scoreUpdate();
		}

		SkillGamesGame3.prototype.showInGameMessage = function (type, x, y) {

			var MESSAGE_TYPE_TOO_CLOSE = 5;

			var $message = $("<div><div class='score'></div><div class='label'><div class='i18n fading-i18n'><div class='fr'></div><div class='en'></div></div></div></div>");
			$message.css({left: x, top: y});

			if (type == MESSAGE_TYPE_LANDED) {
				$message.find(".score").text("+10");
				$message.find(".label .en").text("LANDED");
				$message.find(".label .fr").text("ATTERRI");
				$message.addClass("green");
			} else if (type == MESSAGE_TYPE_WRONG_END) {
				$message.find(".score").text("");
				$message.find(".label .en").text("WRONG END");
				$message.find(".label .fr").text("MAUVAIS BOUT");
				$message.addClass("red");
			} else if (type == MESSAGE_TYPE_TOO_CLOSE) {
				$message.find(".score").text("-10");
				$message.find(".label .en").text("TOO CLOSE");
				$message.find(".label .fr").text("TROP PRÈS");
				$message.addClass("red");
			}

			$("#in-game-messages").append($message)

			// Animate timeline
			var tl = new TimelineMax();

			tl.fromTo($message, 0.2, {
				opacity: 0,
				y: 10,
			}, {
				opacity: 1,
				y: 0,
				ease: Sine.easeInOut,
			}, 0);

			tl.fromTo($message.find(".score"), 0.2, {
				opacity: 0,
				y: 10,
			}, {
				opacity: 1,
				y: 0,
				ease: Sine.easeInOut,
				immediateRender: false,
			}, 0);

			tl.fromTo($message.find(".label"), 0.2, {
				opacity: 0,
				y: 10,
			}, {
				opacity: 1,
				y: 0,
				ease: Sine.easeInOut,
				immediateRender: false,
			}, 0.1);

			tl.to($message.find(".score"), 0.2, {
				opacity: 0,
				y: -10,
				ease: Sine.easeInOut,
				immediateRender: false,
			}, 1.2);

			tl.to($message.find(".label"), 0.2, {
				opacity: 0,
				y: -10,
				ease: Sine.easeInOut,
				immediateRender: false,
			}, 1.3);

			tl.to($message, 0.2, {
				opacity: 0,
				ease: Sine.easeInOut,
				immediateRender: false,
			}, 1.5);

			tl.call(function ($message) {
				$message.remove();
			}, $message);

		}

		SkillGamesGame3.prototype.clearTimerUpdate = function () {
			if (this.timerUpdateInterval != false) {
				clearInterval(this.timerUpdateInterval);
				this.timerUpdateInterval = false;
			}
		}

		SkillGamesGame3.prototype.clearMultipurposeTimer = function () {
			if (this.multipurposeTimer != false) {
				clearInterval(this.multipurposeTimer);
				this.multipurposeTimer = false;
			}
		}

		SkillGamesGame3.prototype.clearGameEventsTimers = function () {
			for (var i = 0; i < this.gameEventsTimers.length; i++) {
				if (this.gameEventsTimers[i] != false) {
					clearInterval(this.gameEventsTimers[i]);
					this.gameEventsTimers[i] = false;
				}
			}
		}

		SkillGamesGame3.prototype.reset = function () {
			this.totaltime = 0;
			this.tries = 0;
			this.score = 0;
			this.levelScore = 0;
			this.planesLaned = 0;
			this.levelPlanesLaned = 0;
			this.playerInteractionAllowed = false;

			this.clearGameEventsTimers();
			this.clearTimerUpdate();
			this.clearMultipurposeTimer();
		}

		// Expose SkillGamesGame3
		window.SkillGamesGame3 = SkillGamesGame3;
	}
)
(jQuery, Promise);
